module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red\"> Invalid entry, the data you have entered is not available. Please try again. </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/proofOfDelivery/podAdvancedShipmentForm/html/errorDisplay.html
// module id = 1375
// module chunks = 1